import { INTEGRATION_USED_BY_COLUMN_ID } from "../constants";
import IntegrationUsedByTableDropdownCell from "./DropdownCell";
import IntegrationUsedByTableNameCell from "./NameCell";
import IntegrationUsedByTableSpaceCell from "./SpaceCell";

export const INTEGRATION_USED_BY_TABLE_CELLS = {
  [INTEGRATION_USED_BY_COLUMN_ID.NAME]: IntegrationUsedByTableNameCell,
  [INTEGRATION_USED_BY_COLUMN_ID.SPACE]: IntegrationUsedByTableSpaceCell,
  [INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: IntegrationUsedByTableDropdownCell,
};
